// extracted by mini-css-extract-plugin
export default {"title":"_2mqjgZla7Z14bpavXRWVlg==","list":"mixVTuNmXvEJFdSJ0UYp6Q==","list-item":"_0fAagmm2MG2KN8Y-hpHppw==","image":"bgQNMRpJhAw4RXhAZFUhtQ=="};